var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Path"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"Welcome","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("g",{"id":"Desktop-HD","transform":"translate(-1336.000000, -38.000000)","fill":"#1F2936","fillRule":"nonzero"},React.createElement("polygon",{"id":"Path","points":"1336 47.7075 1340.32659 43.5 1336 39.2925 1337.33198 38 1343 43.5 1337.33198 49"})))]);
}

ArrowRight.defaultProps = {"width":"7px","height":"11px","viewBox":"0 0 7 11","version":"1.1"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
